import styled from 'styled-components'
import { OrderedList } from 'components/list'

export const EntitiesList = styled(OrderedList)`
    display: flex;
    flex-direction: column;
    row-gap: 16px;

    margin-block-end: var(--__huma-component-modal-content-padding);
    padding-inline: var(--__huma-component-modal-content-padding);

    &.large {
        row-gap: 24px;
    }

    &.nested {
        margin-block: 16px;
        padding-inline: 44px 0;
        position: relative;

        &::before {
            content: "";
            width: 1px;
            height: calc(100% + 8px);
            position: absolute;
            inset-block-start: -8px;
            inset-inline-start: 9.5px;
            background-color: var(--huma-color-border-default);
        }
    }
`